import { Container, Row, Col, Card, Badge } from 'react-bootstrap'

const changelogData = [
  {
    version: 'v1.7.1',
    date: '2026-10-15',
    type: 'fix',
    changes: [
      '临时网络和代理故障自动退避重连，验证游戏连通后续跑中断任务与剩余队列',
      '保留延迟任务和本次消耗额度，当天错过的定时计划合并补跑；支持停止自动恢复',
    ]
  },
  {
    version: 'v1.7.0',
    date: '2026-10-14',
    type: 'feature',
    changes: [
      '新增 Cloudflare 版本：通过同域 HTTPS 转发登录与游戏请求，旧站继续直连游戏',
      '新增独立站点访问口令，可保存、验证、复制和清除，不进入迁移备份',
      '转发故障自动暂停队列、延迟重试与定时执行；刷新后仍暂停，手动恢复时只安排未来计划',
    ]
  },
  {
    version: 'v1.6.0',
    date: '2026-10-14',
    type: 'feature',
    changes: [
      '新增迁移备份 / 恢复：在账号管理页导出账号标识、配置、任务组、答题题库与目标学习数据，支持更换网址后恢复',
      '备份默认不包含密码，可手动勾选；登录 Token、每日计数、日志及定时任务不会迁移',
      '恢复前预览数据并确认覆盖，自动停止旧任务；恢复后可补填密码、手动登录和重新安排任务',
    ]
  },
  {
    version: 'v1.5.0',
    date: '2026-09-05',
    type: 'feature',
    changes: [
      '定时任务与运行日志迁移至全局运行时，切换页面后定时计划持续生效、日志不再丢失',
      '新增「每日凌晨重置运行状态」开关（默认开启）：00:00 中止旧日请求、清空队列和延迟重试，并按当天计划重排定时任务；账号、配置和目标学习数据不受影响',
      '「缘者上钩」定时钓鱼重写：只排最近一个启用时段（上午8点/晚上8点），持续限流时自动顺延重试',
      '「小黑屋」兼容接口返回对象形式的牢笼与战报列表，无空牢笼时日志提示更明确',
    ]
  },
  {
    version: 'v1.4.1',
    date: '2026-08-24',
    type: 'fix',
    changes: [
      '修复「共建桃园」农田成熟后未自动一键收获和补种的问题',
    ]
  },
  {
    version: 'v1.4.0',
    date: '2026-08-23',
    type: 'feature',
    changes: [
      '新增「经脉扫荡」任务，自动扫荡经脉丹药精华副本中全部已开启页签和难度',
    ]
  },
  {
    version: 'v1.3.0',
    date: '2026-05-23',
    type: 'feature',
    changes: [
      '新增「蹴鞠大赛」任务，支持自动消耗免费次数并按配置兑换奖券奖励',
      '新增「皇城探宝」任务，支持按目标积分自动掷骰、战斗、购买指定商店道具并领取积分奖励',
      '新增「征战八方领奖」任务，自动领取今日任务奖励和抽奖成就奖励',
      '新增「黑市刷新购买」任务，支持按商品目标、折扣和刷新预算自动购买指定物品',
      '新增「天赋卷轴扫荡」任务，支持自动扫荡并领取奖励',
      '新增「平乱扫荡」任务，每日自动执行普通难度普通关卡和BOSS关卡扫荡',
      '新增「魔宠探险」任务，支持自动派遣和领取探险奖励',
      '新增「招募雄兵」任务，支持自动刷新兵源、招募雄兵5/23，并在三星后售卖',
      '优化八卦阵、铜雀台、地下城、福利抽奖、自动采矿、全民翻牌、通天塔、世界Boss、英雄王座等任务的执行和日志反馈',
      '优化任务配置体验，部分任务可刷新加载可选目标，并保留已选择项名称',
      '优化定时任务表现，任务失败后仍会安排下一次执行，减少活动漏跑',
    ]
  },
  {
    version: 'v1.2.0',
    date: '2025-12-05',
    type: 'feature',
    changes: [
      '新增「强化出售」任务，自动出售强化满级的低品质装备',
      '新增「精英副本」任务，在每次重置后自动推图挑战',
      '「端午节任务」任务新增秘宝烧艾草功能, 每个时间段自动执行10次',
      '「国庆活动」任务新增秘宝兑换功能，支持选择兑换物品',
      '新增更新日志页面，方便了解版本更新内容',
    ]
  },
  {
    version: 'v1.0.0',
    date: '2025-09-15',
    type: 'release',
    changes: [
      '首次发布',
      '支持账号管理功能',
      '支持组管理功能',
      '支持日常任务自动执行',
    ]
  }
]

const getTypeBadge = (type) => {
  const typeMap = {
    feature: { bg: 'success', text: '新功能' },
    fix: { bg: 'warning', text: '修复' },
    improvement: { bg: 'info', text: '优化' },
    release: { bg: 'primary', text: '发布' }
  }
  const config = typeMap[type] || typeMap.release
  return <Badge bg={config.bg}>{config.text}</Badge>
}

const Changelog = () => {
  return (
    <Container fluid>
      <Row className="mb-4">
        <Col xs={12}>
          <Card>
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h4 className="card-title text-primary mb-1">📝 更新日志</h4>
                  <p className="card-text text-muted mb-0">查看版本更新历史和新功能介绍</p>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          {changelogData.map((release, index) => (
            <Card key={index} className="mb-3">
              <Card.Header className="d-flex justify-content-between align-items-center">
                <div>
                  <strong className="me-2">{release.version}</strong>
                  {getTypeBadge(release.type)}
                </div>
                <small className="text-muted">{release.date}</small>
              </Card.Header>
              <Card.Body>
                <ul className="mb-0">
                  {release.changes.map((change, idx) => (
                    <li key={idx}>{change}</li>
                  ))}
                </ul>
              </Card.Body>
            </Card>
          ))}
        </Col>
      </Row>
    </Container>
  )
}

export default Changelog
